import type { CompareOverviewRecord } from '@/services/SalesforceService';

import type {
  CompareOverviewReaderIterator,
  CompareOverviewReader,
} from './interfaces';
import PageSeparator from './PageSeparator';
import CancelToken from './CancelToken';

export default class CachedCompareOverviewReader
  implements CompareOverviewReader
{
  private iterator!: CompareOverviewReaderIterator;
  private cache: CompareOverviewRecord[];

  constructor(private readonly compareOverviewReader: CompareOverviewReader) {
    this.cache = [];
    this.resetIterator();
  }

  resetIterator(): void {
    const self = this;
    this.iterator = (async function* generator() {
      for (const compareOverviewRecord of self.cache) {
        yield compareOverviewRecord;
      }

      for await (const compareOverviewRecord of self.compareOverviewReader.getIterator()) {
        if (compareOverviewRecord instanceof PageSeparator) {
          yield compareOverviewRecord;
          continue;
        }

        if (compareOverviewRecord instanceof CancelToken) {
          yield compareOverviewRecord;
          continue;
        }

        self.cache.push(compareOverviewRecord);
        yield compareOverviewRecord;
      }
    })();
  }

  getIterator(): CompareOverviewReaderIterator {
    return this.iterator;
  }

  cancel(): void {
    this.compareOverviewReader.cancel();
  }
}
